import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const createConsultationApi = (base) => ({
  submitPublic: async (data) => {
    const response = await api.request({
      url: "ConsultationPublic/Submit",
      method: "POST",
      data,
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  },

  getPagedList: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetPagedList?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getDetail: async (id) => {
    const response = await api.request({
      url: `${base}/GetDetail?${queryString.stringify({ id })}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  updateRequest: async (data) => {
    const response = await api.request({
      url: `${base}/UpdateRequest`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  addFollowUp: async (data) => {
    const response = await api.request({
      url: `${base}/AddFollowUp`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  setTags: async (data) => {
    const response = await api.request({
      url: `${base}/SetTags`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  getTags: async () => {
    const response = await api.request({
      url: `${base}/GetTags`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getStatuses: async () => {
    const response = await api.request({
      url: `${base}/GetStatuses`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  saveTag: async (data) => {
    const response = await api.request({
      url: `${base}/SaveTag`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  saveStatus: async (data) => {
    const response = await api.request({
      url: `${base}/SaveStatus`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  deleteTag: async (id) => {
    const response = await api.request({
      url: `${base}/DeleteTag?${queryString.stringify({ id })}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  deleteStatus: async (id) => {
    const response = await api.request({
      url: `${base}/DeleteStatus?${queryString.stringify({ id })}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  getSettings: async () => {
    const response = await api.request({
      url: `${base}/GetSettings`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  saveSettings: async (data) => {
    const response = await api.request({
      url: `${base}/SaveSettings`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  getReport: async () => {
    const response = await api.request({
      url: `${base}/GetReport`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getExperts: async () => {
    const response = await api.request({
      url: `${base}/GetExperts`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  convertToUser: async (consultationRequestId) => {
    const response = await api.request({
      url: `${base}/ConvertToUser?${queryString.stringify({ consultationRequestId })}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  exportCsv: async (params = {}) => {
    return api.request({
      url: `${base}/ExportCsv?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob",
    });
  },

  exportCsvUrl: (params = {}) =>
    `${window.globalConfig?.API_URL || ""}/${base}/ExportCsv?${queryString.stringify(params)}`,
});

const ConsultationApi = createConsultationApi("SLN/Management/Consultation");
export const consultationSolarentOperatorApi = createConsultationApi(
  "SLN/SolarentOperator/Consultation"
);

export default ConsultationApi;
